import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import UploadSection from "./UploadSection";
import { FaEye, FaChevronRight, FaChevronDown } from "react-icons/fa";
import History from "../../../../Analysis/ComponentsAnalysis/HistoryAdequacao/History";

function slugify(text) {
  if (!text) return "";
  let slug = text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
  slug = slug.replace(/^\d+-/, "");
  return slug;
}

const mapHistoricoToInitialValue = (historicoItem) => {
  if (!historicoItem) return {};
  return {
    status:
      historicoItem.conforme === true
        ? "CONFORME"
        : historicoItem.conforme === false
          ? "NAO_CONFORME"
          : null,
    observacao: historicoItem.observacao || "",
    solicitadoEm: historicoItem.dataSolicitacao || "",
    obsAnalista: historicoItem.obsAnalista || "",
    adequadoEm: historicoItem.dataAdequacao || "",
    obsSindicato: historicoItem.obsSindicato || "",
    adequacaoRealizada: historicoItem.adequacaoRealizada || false,
  };
};

const temSolicitacaoAdequacao = (campo, historico, modoAdequacao) => {
  if (!modoAdequacao || !campo) return false;
  const slugOrigem =
    campo?.idCampoJson || campo?.nomeArquivo || campo?.titulo || "";
  const campoSlug = slugify(slugOrigem);
  const historicoKeys = Object.keys(historico || {});
  const temaSlug = campoSlug;
  const matchKey = historicoKeys.find((key) => slugify(key) === temaSlug);
  return (
    matchKey &&
    typeof historico[matchKey]?.dataSolicitacao === "string" &&
    historico[matchKey]?.adequacaoRealizada !== true
  );
};

const renderAlternatives = (
  alternativas,
  depth = 0,
  path = [],
  handlePathChange,
  selectedPaths,
  data,
  idResposta,
  onFileUpload,
  uploadedFiles,
  historico,
  modoAdequacao,
  disabled,
) => {
  return (
    <>
      {alternativas.map((alt, idx) => {
        const altKey = alt.valor || alt.titulo;
        const currentPath = [...path, altKey];
        const pathKey = currentPath.filter(Boolean).join(".");
        const isSelected = selectedPaths[pathKey] === altKey;

        const isEditavel =
          (!modoAdequacao && !disabled) ||
          (modoAdequacao &&
            temSolicitacaoAdequacao(alt, historico, modoAdequacao));

        return (
          <div key={idx} className={`ms-${depth * 3}`}>
            <Form.Check
              type="radio"
              label={altKey}
              name={`alt-${data.id}-${depth}-${path.join("-")}`}
              checked={isSelected}
              onChange={() => handlePathChange(pathKey, altKey)}
              disabled={!isEditavel}
            />
            {isSelected && alt.campo && (
              <div className="mt-2">
                {alt.campo.map((campo, i) => {
                  const podeTrocarArquivo =
                    campo?.nomeArquivo &&
                    temSolicitacaoAdequacao(campo, historico, modoAdequacao);

                  if (campo.tipoCampo === "radio") {
                    return (
                      <div key={i} className="ms-3">
                        {renderAlternatives(
                          campo.alternativa,
                          depth + 1,
                          currentPath,
                          handlePathChange,
                          selectedPaths,
                          data,
                          idResposta,
                          onFileUpload,
                          uploadedFiles,
                          historico,
                          modoAdequacao,
                          disabled,
                        )}
                      </div>
                    );
                  }

                  if (campo.tipoCampo === "pdf") {
                    return (
                      <div key={i} className="ms-3">
                        <UploadSection
                          idResposta={idResposta}
                          nomeArquivo={campo.nomeArquivo}
                          onUpload={(nome, files) => onFileUpload(nome, files)}
                          uploadedFiles={uploadedFiles}
                          podeTrocarArquivo={modoAdequacao && podeTrocarArquivo}
                          modoAdequacao={modoAdequacao}
                          disabled={!isEditavel}
                        />
                      </div>
                    );
                  }

                  return null;
                })}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

const Topic = ({
  data,
  hasError,
  onOptionSelect,
  onFileUpload,
  idResposta,
  uploadedFiles,
  selectedOptions,
  disabled,
  onAnalysisChange,
  historico,
  modoAdequacao,
  isOpen: isOpenProp,
  onToggle: onToggleProp,
}) => {
  const [selectedMainOption, setSelectedMainOption] = useState("");
  const [selectedPaths, setSelectedPaths] = useState({});

  const [localOpen, setLocalOpen] = useState(false);
  const isControlled = isOpenProp !== undefined && typeof onToggleProp === "function";
  const isOpen = isControlled ? isOpenProp : localOpen;
  const handleToggle = isControlled ? onToggleProp : () => setLocalOpen((prev) => !prev);

  function handlePathChange(pathKey, value) {
    const newPaths = { ...selectedPaths, [pathKey]: value };
    setSelectedPaths(newPaths);
    onOptionSelect(data.id, {
      resposta: selectedMainOption,
      caminhos: newPaths,
    });
  }

  useEffect(() => {
    const selected = selectedOptions[data.id] || {};
    setSelectedMainOption(selected.resposta || "");
    setSelectedPaths(selected.caminhos || {});
  }, [selectedOptions, data.id]);

  const slugKey = slugify(data.idCampoJson);
  const historicoEntryKey = Object.keys(historico || {}).find(
    (key) => slugify(key) === slugKey,
  );
  const historicoItem = historicoEntryKey ? historico[historicoEntryKey] : null;

  return (
    <Card className={`mb-4 ${hasError ? "error-card" : ""}`}>
      <Card.Body>
        <button
          type="button"
          onClick={handleToggle}
          className="w-100 d-flex justify-content-between align-items-center"
          style={{
            background: "transparent",
            border: "none",
            padding: 0,
            textAlign: "left",
          }}
          aria-expanded={isOpen}
        >
          <div className="d-flex align-items-center gap-2">
            {isOpen ? (
              <FaChevronDown style={{ color: "#6c757d" }} />
            ) : (
              <FaChevronRight style={{ color: "#6c757d" }} />
            )}

            <Card.Title className="fw-bold mb-0">{data.title}</Card.Title>
          </div>

          {data.link ? (
            <a
              href={data.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary text-decoration-none d-flex align-items-center"
              onClick={(e) => e.stopPropagation()}
            >
              <FaEye className="me-2" /> Ver modelo
            </a>
          ) : (
            <span />
          )}
        </button>

        {isOpen && (
          <Form className="mt-2">
            {data.criterios.map((criterio, idx) => {
              const campos = criterio.campo || [];
              const isMainRadio =
                idx === 0 &&
                campos.length > 0 &&
                campos[0].tipoCampo === "radio" &&
                !campos[0].nomeArquivo;

              return (
                <div key={idx} className="mb-3">
                  {criterio.titulo &&
                    (isMainRadio || selectedMainOption === "SIM") && (
                      <Form.Label className="fw-semibold">
                        {criterio.titulo}
                      </Form.Label>
                    )}

                  {isMainRadio && (
                    <Form.Group className="mt-2">
                      <Form.Check
                        type="radio"
                        label="SIM"
                        name={`main-${data.id}`}
                        value="SIM"
                        checked={selectedMainOption === "SIM"}
                        onChange={() => {
                          setSelectedMainOption("SIM");
                          onOptionSelect(data.id, {
                            resposta: "SIM",
                            caminhos: selectedPaths,
                          });
                        }}
                        disabled={
                          (!modoAdequacao && disabled) ||
                          (modoAdequacao &&
                            !temSolicitacaoAdequacao(
                              data,
                              historico,
                              modoAdequacao,
                            ))
                        }
                      />
                      <Form.Check
                        type="radio"
                        label="NÃO"
                        name={`main-${data.id}`}
                        value="NÃO"
                        checked={selectedMainOption === "NÃO"}
                        onChange={() => {
                          setSelectedMainOption("NÃO");
                          onOptionSelect(data.id, {
                            resposta: "NÃO",
                            caminhos: {},
                          });
                        }}
                        disabled={
                          (!modoAdequacao && disabled) ||
                          (modoAdequacao &&
                            !temSolicitacaoAdequacao(
                              data,
                              historico,
                              modoAdequacao,
                            ))
                        }
                      />
                    </Form.Group>
                  )}

                  {selectedMainOption === "SIM" &&
                    campos
                      .filter((_, i) => !isMainRadio || i > 0)
                      .map((campo, i) => {
                        if (campo.tipoCampo === "radio") {
                          return (
                            <div key={i} className="mt-2">
                              {renderAlternatives(
                                campo.alternativa,
                                0,
                                [],
                                handlePathChange,
                                selectedPaths,
                                data,
                                idResposta,
                                onFileUpload,
                                uploadedFiles,
                                historico,
                                modoAdequacao,
                                disabled,
                              )}
                            </div>
                          );
                        }
                        if (campo.tipoCampo === "pdf") {
                          const podeTrocarArquivo =
                            campo?.nomeArquivo &&
                            temSolicitacaoAdequacao(
                              campo,
                              historico,
                              modoAdequacao,
                            );
                          return (
                            <div key={i} className="mt-2">
                              <UploadSection
                                idResposta={idResposta}
                                nomeArquivo={campo.nomeArquivo}
                                onUpload={(nome, files) =>
                                  onFileUpload(nome, files)
                                }
                                uploadedFiles={uploadedFiles}
                                podeTrocarArquivo={
                                  modoAdequacao && podeTrocarArquivo
                                }
                                disabled={disabled}
                                modoAdequacao={modoAdequacao}
                              />
                            </div>
                          );
                        }
                        return null;
                      })}
                </div>
              );
            })}
          </Form>
        )}
      </Card.Body>

      {historicoItem?.dataSolicitacao && (
        <History
          idCampo={slugKey}
          initialValue={mapHistoricoToInitialValue(historicoItem)}
          onChange={onAnalysisChange}
          isSindicato={true}
        />
      )}
    </Card>
  );
};

export default Topic;
